import { Link } from "@tanstack/react-router";
import { useSelectedEvent } from "@/lib/event-context";
import { resolveEventLogoUrl } from "@/lib/events";
import { cn } from "@/lib/utils";

export function EventLogo({ className }: { className?: string }) {
  const { selectedEvent } = useSelectedEvent();
  const logoUrl = resolveEventLogoUrl(selectedEvent?.logo_url);

  if (!logoUrl) return null;

  return (
    <Link
      to="/"
      className={cn("flex max-w-full items-center", className)}
      title={selectedEvent?.title}
    >
      <img
        src={logoUrl}
        alt={selectedEvent?.title || "Event logo"}
        className="h-12 w-auto max-w-[200px] object-contain md:h-14 lg:h-16"
      />
    </Link>
  );
}
